import React, { useContext, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { Grid  } from "@material-ui/core";
import DailyHiLo from "../../components/DailyHiLo";
import {setLastTrade} from "store/actions";
import { makeStyles, useTheme } from "@material-ui/styles";
import colors from 'assets/scss/_themes-vars.module.scss';

import {
  createChart,
  createPriceLine,
  CrosshairMode,
} from "lightweight-charts";
import CoinContext from "contexts/CoinContext";
import { useSelector, useDispatch } from "react-redux";
import I from "immutable";
import axios from "axios";
// 1. No duplicates in the CandleStick Time Series
// 2. All time values must be Ascending order (increasing)
// 3. No NULL values in OHLC for that timestamp

const useStyles = makeStyles((theme) => ({
}));

function centerToTime(chart, targetTime) {
    const timeScale = chart.timeScale();
    const coordinate = timeScale.timeToCoordinate(targetTime);

    if (coordinate === null) return; // Time is not visible or loaded

    const logicalIndex = timeScale.coordinateToLogical(coordinate);
    const visibleLogicalRange = timeScale.getVisibleLogicalRange();
    // TMD console.log( 'visibleLogicalRange');
    // TMD console.log( visibleLogicalRange);

    if (visibleLogicalRange === null) return;

    // TMD console.log( 'logicalIndex');
    // TMD console.log(logicalIndex);

    const currentScrollPosition = timeScale.scrollPosition();
    // TMD console.log( 'currentScrollPosition');
    // TMD console.log(currentScrollPosition);
    // const visibleCenter = visibleLogicalRange.from + (visibleLogicalRange.to - visibleLogicalRange.from) / 2;
    // const offset = visibleCenter - logicalIndex;

    timeScale.scrollToPosition((logicalIndex - visibleLogicalRange.from), false);
}

const MarketShareAreaChartCard = (coin_label) => {

  const [interval, setInterval] = useState("1");
  const [previousCoin, setPreviousCoin] = useState("");
  const [previousTS, setPreviousTS] = useState(0);
  const [prevMacdTS, setPrevMacdTS] = useState(0);
  const [fetchTrigger, setFetchTrigger] = useState(0); // 1. The state to trigger the effect
  const [chartUpdated, setChartUpdated] = useState(false); // 1. The state to trigger the effect
  const [chartCentered, setChartCentered] = useState(false); // 1. The state to trigger the effect

    // console.log(oData);
    // console.log(pData);

  const handleClick = () => {
    if ( oData !== undefined && pData !== undefined && !chartCentered)
    {
        const pIndex = Math.floor(pData.length/2);
        console.log(pIndex + ', ' + pData[pIndex]);
        centerToTime(chart.current, pData[pIndex].time);
        setChartCentered(true);
    }
  };

  const chartContainerRef = useRef();
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const cornsilk = (theme.palette.mode === 'dark') ? 'white' : colors.cornsilkDarkTakyon;
  const whiteTakyon = (theme.palette.mode === 'dark') ? colors.whiteLightTakyon : colors.whiteDarkTakyon;
  const green = (theme.palette.mode === 'dark') ? colors.successLightTakyon : colors.successMain;
  const red = (theme.palette.mode === 'dark') ? colors.errorLightTakyon : colors.errorDarkTakyon;
  const bgcolor = (theme.palette.mode === 'dark') ? '#010F17' : 'white';
  // const bgcolor = theme.palette.background.paper;

  const chart = useRef();
  const series = useRef();
  const lineSeries = useRef();

  const resizeObserver = useRef();
  const coin = coin_label.coin_label;

  const oData = useSelector((state) => { return state.chart.ohlcDataMap.get(coin);});
  const pData = useSelector((state) => { return state.chart.predDataMap.get(coin);});

  // TMD console.log('CHART......oData, pData.    ' + coin);
  // TMD console.log(oData);
  // TMD console.log(pData);

  useEffect(() => {
    // TMD console.log( 'USE EFFECT------ CREATE CHART');
    // init chart, do not modify here
    chart.current = createChart(chartContainerRef.current, {
      height: 500,
      layout: {
        backgroundColor: bgcolor,
        textColor: cornsilk,
      },
      grid: {
        vertLines: {
            visible: false,
            color: "#111",
        },
        horzLines: {
            visible: false,
            color: "#111",
        },
      },
      crosshair: {
        vertLine: {
          color: "#333",
          width: 0.1,
          style: 0,
          visible: true,
          labelVisible: true,
        },
        horzLine: {
          color: "#333",
          width: 0.1,
          style: 0,
          visible: true,
          labelVisible: true,
        },
        mode: CrosshairMode.Normal,
      },
      priceScale: {
        borderColor: "#888",
        borderVisible: false,
      },
      alignLabels: true,
      timeScale: {
        rightOffset: 10,
        barSpacing: 8,
        fixLeftEdge: false,
        lockVisibleTimeRangeOnResize: true,
        rightBarStaysOnScroll: true,
        borderVisible: false,
        borderColor: "#888",
        visible: true,
        timeVisible: true,
        secondsVisible: true,
      },
    });

    const candleSeries = chart.current.addCandlestickSeries({
      upColor: green,
      downColor: red,
      borderUpColor: green,
      borderDownColor: red,
      wickUpColor: green,
      wickDownColor: red,
    });
    // candleSeries.setData(oData);

    lineSeries.current = chart.current.addLineSeries({
        color: '#2962FF',
        lineWidth: 2,
    });
    // lineSeries.setData(pData);

    series.current = candleSeries;
 
  }, []);

  useEffect(() => {
    if ( !chartUpdated)
    {
        if ( oData !== undefined && oData.length > 0)
        {
            series.current.setData(oData);
            setChartUpdated(true);
        }
        if ( pData !== undefined && pData.length > 0)
        {
            lineSeries.current.setData(pData);
            // TMD console.log( 'CHART ------------ ' + coin + ', ......... ' + pData[0].time);
        }
        if ( oData !== undefined && pData !== undefined && !chartCentered)
        {
            const pIndex = Math.floor(pData.length/2);
            console.log(pIndex + ', ' + pData[pIndex]);
            centerToTime(chart.current, pData[pIndex].time);
            setChartCentered(true);
        }
    }
  }, [chartUpdated]);
  return (
          <div class={classes.chart} onClick={handleClick} ref={chartContainerRef} />
  );
};
export default React.memo(MarketShareAreaChartCard);
